var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToEnterButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 314,
    height: 199,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "howToEnterButtonIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 370",
    fill: "none",
    d: "M0 0h199v199H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "howToEnterButtonIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 376",
    fill: "none",
    d: "M0 0h184v184H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#howToEnterButtonIcon_svg__a)",
    transform: "translate(115)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 368",
    fill: "#060404"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 498",
    d: "M157.541 181.86H41.458v-4.975a3.317 3.317 0 013.317-3.316h109.45a3.317 3.317 0 013.317 3.317z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 499",
    d: "M143.864 174.217H55.139v-14.925a9.95 9.95 0 019.95-9.95h68.821a9.95 9.95 0 019.95 9.95z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#howToEnterButtonIcon_svg__b)",
    fill: "#060404",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 374",
    d: "M87.478 147.758l18.086-31.325 1.593.92-18.086 31.325z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 375",
    d: "M99.874 147.757l14.867-25.75 1.594.92-14.868 25.75z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 503",
    d: "M141.702 113.577a24.146 24.146 0 11-8.838-32.984 24.146 24.146 0 018.838 32.984"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 504",
    d: "M145.666 168.153H38.333V152.82a6.134 6.134 0 016.133-6.133h95.067a6.134 6.134 0 016.133 6.133z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToEnterButtonIcon);
export default __webpack_public_path__ + "static/media/howToEnterButtonIcon.642ccd0b0cc04cc8.svg";
export { ForwardRef as ReactComponent };